module.exports = __webpack_public_path__ + "static/media/backend_small_banner.6517a304.jpg";